/* unplugin-vue-components disabled */import script from "./FilePreviewDialog.vue?vue&type=script&setup=true&name=FilePreviewDialog&lang=js"
export * from "./FilePreviewDialog.vue?vue&type=script&setup=true&name=FilePreviewDialog&lang=js"

import "./FilePreviewDialog.vue?vue&type=style&index=0&id=64ff27cf&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ff27cf"]])

export default __exports__